import ProtectedRoute from 'components/ProtectedRoute'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import useFlag from 'hooks/useFlag'
import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { useServiceChargePermissions } from 'scenes/OperationsCenter/Locations/Detail/ServiceCharges/useServiceChargePermissions'
import OperationsCenterServiceChargeGroups from 'scenes/OperationsCenter/Locations/ServiceChargeGroups'
import GroupLocationsDrillDown from 'scenes/OperationsCenter/Locations/ServiceChargeGroups/GroupLocationsDrillDown'

// `/service_charges` is the canonical route for the group list + its
// drill-down. Gated on `operations-center` (an OC-only surface, like
// PosConfigurations) plus the same business gate as the per-location
// section (`manage-service-charges-mx`, `supports_service_charges`, the
// OrderingManagement RBAC view grant) — consistent access with the Detail page.
const ServiceChargeGroups = () => {
  const operationsCenterEnabled = useFlag('operations-center', false)
  const serviceChargesFlag = useFlag('manage-service-charges-mx', false)
  const merchant = useCurrentMerchant()
  const { sectionHidden } = useServiceChargePermissions()
  const canAccess =
    serviceChargesFlag &&
    Boolean(merchant?.supports_service_charges) &&
    !sectionHidden

  if (!operationsCenterEnabled || !canAccess) {
    return <Redirect to="/" />
  }

  return (
    <Switch>
      <ProtectedRoute
        redirect="/"
        accessType="access"
        resource="Locations"
        exact
        path="/service_charges/:providerUid"
        component={GroupLocationsDrillDown}
      />
      <ProtectedRoute
        redirect="/"
        accessType="access"
        resource="Locations"
        exact
        path="/service_charges"
        component={OperationsCenterServiceChargeGroups}
      />
    </Switch>
  )
}

export default ServiceChargeGroups
